import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
    import { useRoute } from '@common/composables'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'MySharesPage',
  setup(__props) {

    document.title = 'Shares'

    const tid = useRoute().params.tid

    const shares = [
        {
            Id: '311901D5-762C-4B5A-BCC1-C822C010780F',
            Workspace: 'Default',
            Portfolio: 'Mega Portfolio',
            Data: 'Final Report',
            SharedBy: 'janusz@transparentchoice.com',
            SharedWith: 'dan@transparentchoice.com, stuart@transparentchoice.com',
            SharedAt: '2023-10-15',
            SharedFor: '7 days',
        },
        {
            Id: '311901D5-762C-4B5A-BAC1-C822C010780F',
            Workspace: 'Default',
            Portfolio: 'Mega Portfolio',
            Data: 'Request Page',
            SharedBy: 'janusz@transparentchoice.com',
            SharedWith: 'dawid@transparentchoice.com, saulo@transparentchoice.com',
            SharedAt: '2023-10-15',
            SharedFor: '90 days',
        },
    ]

return { __sfc: true,tid, shares }
}

})